/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CurrencyExchangeConfigurationBatchResponse {
    getFixupPrototypeFunction() { return CurrencyExchangeConfigurationBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<CurrencyExchangeConfigurationBatchResponse>): CurrencyExchangeConfigurationBatchResponse {
        let obj = Object.assign(new CurrencyExchangeConfigurationBatchResponse(), model);
        CurrencyExchangeConfigurationBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CurrencyExchangeConfigurationBatchResponse>): CurrencyExchangeConfigurationBatchResponse {
        if (!model) return null;
        return CurrencyExchangeConfigurationBatchResponse.newInstance(<CurrencyExchangeConfigurationBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CurrencyExchangeConfigurationBatchResponse) {
        if (!obj) return;

        models.CurrencyExchangeConfigurationBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CurrencyExchangeConfigurationBatchResponse): boolean {
        Object.setPrototypeOf(obj, CurrencyExchangeConfigurationBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.CurrencyExchangeConfigurationDefinition.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.CurrencyExchangeConfigurationDefinition; };

}
